import {$swoole} from './axios.setup'

// getReportInspectionOverseas
// - 2026.03.26
// - 2026.07.07 version 'v1' hits the appraiseV1 endpoint (出口车检测报告);
//   the response shape is identical to appraise
export const getReportInspectionOverseas = async ({params, version}) => {
  const url = version === 'v1'
    ? '/v1/vehicleInspection/exportCar/appraiseV1'
    : '/v1/vehicleInspection/exportCar/appraise'
  const res = await $swoole.get(url, {
    params,
  })

  return res.data.data
}
